import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { useIdentityChallengeContext } from 'Context/IdentityChallengeContext';
import BackToChallengeButton from './BackToChallengeButton';

const BackToChallengeButtonPicker = (props) => {
  const { challengeFlowCollection } = useIdentityChallengeContext();
  const [challengeFlowResource] = challengeFlowCollection;

  return pickFunction(challengeFlowResource, {
    [fr.relationships.currentMfaChallenge.name]: () => {
      return (
        <BackToChallengeButton {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default BackToChallengeButtonPicker;
